import CTAButton from "./CTAButton";
import { useHome } from "../../data/content";

function HeroCTA() {
  const home = useHome();

  return (
    <div className="flex items-center gap-3 mt-8">
      <CTAButton
        label={home.heroPrimaryCta}
        variant="filled"
        onClick={() => document.getElementById("featured-work")?.scrollIntoView({ behavior: "smooth" })}
      />
      <CTAButton
        label={home.heroSecondaryCta}
        variant="outline"
        onClick={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
      />
    </div>
  );
}

export default HeroCTA;
